import { get } from '../../../common/utils/objectUtils';
import {
    TRACKING_GTM,
    TrackingActionTypes,
    TrackingState,
    UNIVERSAL_ANALYTICS_SESSION_INIT_DID_FIRE_PAYLOAD_PROP,
} from './types';

const initState: TrackingState = {
    universalAnalyticsSessionInitDidFire: false,
};

const TrackingReducers = (state: TrackingState, action: TrackingActionTypes): TrackingState => {
    switch (action.type) {
        case TRACKING_GTM:
            return state.universalAnalyticsSessionInitDidFire
                ? state
                : {
                      ...state,
                      universalAnalyticsSessionInitDidFire: get(
                          action.payload,
                          UNIVERSAL_ANALYTICS_SESSION_INIT_DID_FIRE_PAYLOAD_PROP,
                          initState.universalAnalyticsSessionInitDidFire
                      ),
                  };
        default:
            return state || initState;
    }
};

export default TrackingReducers;
